import { Component, ElementRef, OnInit } from '@angular/core';
import { HelpSupportModalService } from './help-support-modal.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { OrganizationService } from 'src/app/modules/obsolete/components/organization/organization.service';
import { UsersService } from 'src/app/modules/management/components/tabs/components/users/users.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
@Component({
	selector: 'app-help-support-modal',
	templateUrl: './help-support-modal.component.html',
	styleUrls: ['./help-support-modal.component.scss']
})
export class HelpSupportModalComponent implements OnInit {
	supportCategoriesData: any;
	noLoginCategories: any;
	isCategorySelected: boolean = false;
	selectedCategory: any;
	selectedSubcat: any;
	showForm: any = true;
	showVideoModal = false;
	selectedVideoUrl: any;
	contactEmail: string = "";
	contactMessage: string = "";
	blockLoader = "blockLoader";
	selectedContactReason = "";
	selectedReasonIndex: number = 0;
	emailRegex = /^\S+@\S+\.\S+$/;
	imageFiles: string[] = [];
	isUserLoggedIn: boolean = false;
	files: File[] = [];
	selectedOrganizationName: string = ''
	filteredOrganizations: any[] = [];
	fullName: string = '';
	userName: string = ''
	userDetails: any;
	contactUsData: any;
	shouldEmailBeDisabled = false;
	store: string = '';
	// @ViewChild('boxElement') boxElement!: ElementRef;
	// dyanamicWidth:number = 0;
	// @HostListener('window:resize', ['$event'])
	// onResize(event:any) {
	// 	this.getBoxDimensions();
	// }

	constructor(
		private snackbar: MatSnackBar,
		private spinner: NgxSpinnerService,
		private helpSupportService: HelpSupportModalService,
		public dialogRef: MatDialogRef<HelpSupportModalComponent>,
		private sanitizer: DomSanitizer,
		private el: ElementRef,
		private organizationService: OrganizationService,
		private usersService: UsersService
	) {
		if (localStorage.getItem("userId")) {
			this.isUserLoggedIn = true;
		} else {
			this.isUserLoggedIn = false;
		}
	}

	async ngOnInit() {
		// this.supportCategoriesData = await this.helpSupportService.getSupportCategoriesData();

		// old json
		await this.getUserData();
		// this.supportCategoriesData = [
		// 	{
		// 		"name": "Learning Center",
		// 		"doesRequireLogin": false,
		// 		"icon": "../../../../../assets/images/learn.png",
		// 		"subCategories": [
		// 			{
		// 				"name": "How To Videos",
		// 				"type": "video",
		// 				"data": [
		// 					{
		// 						"title": "Video 1",
		// 						"thumbnail": "https://www.firebase.com/storage/images/vid1img",
		// 						"url": "../../../../../assets/images/videoSample.mp4"
		// 					},
		// 					{
		// 						"title": "Video 2",
		// 						"thumbnail": "https://www.firebase.com/storage/images/vid2img",
		// 						"url": "../../../../../assets/images/videoSample.mp4"
		// 					},
		// 					{
		// 						"title": "Video 1",
		// 						"thumbnail": "https://www.firebase.com/storage/images/vid1img",
		// 						"url": "../../../../../assets/images/videoSample.mp4"
		// 					},
		// 					{
		// 						"title": "Video 2",
		// 						"thumbnail": "https://www.firebase.com/storage/images/vid2img",
		// 						"url": "../../../../../assets/images/videoSample.mp4"
		// 					},
		// 					{
		// 						"title": "Video 1",
		// 						"thumbnail": "https://www.firebase.com/storage/images/vid1img",
		// 						"url": "../../../../../assets/images/videoSample.mp4"
		// 					},
		// 					{
		// 						"title": "Video 2",
		// 						"thumbnail": "https://www.firebase.com/storage/images/vid2img",
		// 						"url": "../../../../../assets/images/videoSample.mp4"
		// 					}
		// 				]
		// 			},
		// 			{
		// 				"name": "FAQ",
		// 				"type": "faq",
		// 				"data": [
		// 					{
		// 						"question": "Lorem ipsum dolor sit amet, consectetur adipiscing el",
		// 						"answer": "Lorem ipsum dolor sit amet, consectetur adipiscing elats sksmarksseparat odio"
		// 					},
		// 					{
		// 						"question": "Lorem ipsum dolor sit amet, consectetur adipiscing el",
		// 						"answer": "Lorem ipsum dolor sit amet, consectetur adipiscing elats sksmarksseparat odio"
		// 					}
		// 				]
		// 			},
		// 			{
		// 				"name": "Contact Us",
		// 				"type": "contact",
		// 				"mailTo": [], // change this later on
		// 				"data": [
		// 					{
		// 						"reason": "Reason 1 specification",
		// 						"instruction": "To help you faster, please supply screenshots where possible. Thanks! 😀",
		// 						"uploadRequired": true
		// 					},
		// 					{
		// 						"reason": "Reason 2 specification",
		// 						"instruction": "",
		// 						"uploadRequired": false
		// 					}
		// 				]
		// 			}
		// 		]
		// 	},
		// 	{
		// 		"name": "Management",
		// 		"doesRequireLogin": true,
		// 		"icon": "../../../../../assets/images/management.png",
		// 		"subCategories": [
		// 			{
		// 				"name": "How To Videos",
		// 				"type": "video",
		// 				"data": [
		// 					{
		// 						"title": "Video 1",
		// 						"thumbnail": "https://www.firebase.com/storage/images/vid1img",
		// 						"url": "http://www.firebase.com/storage/videos/video1"
		// 					},
		// 					{
		// 						"title": "Video 2",
		// 						"thumbnail": "https://www.firebase.com/storage/images/vid2img",
		// 						"url": "http://www.firebase.com/storage/videos/video2"
		// 					}
		// 				]
		// 			},
		// 			{
		// 				"name": "FAQ",
		// 				"type": "faq",
		// 				"data": [
		// 					{
		// 						"question": "Lorem ipsum dolor sit amet, consectetur adipiscing el",
		// 						"answer": "Lorem ipsum dolor sit amet, consectetur adipiscing elats sksmarksseparat odio"
		// 					},
		// 					{
		// 						"question": "Lorem ipsum dolor sit amet, consectetur adipiscing el",
		// 						"answer": "Lorem ipsum dolor sit amet, consectetur adipiscing elats sksmarksseparat odio"
		// 					}
		// 				]
		// 			},
		// 			{
		// 				"name": "Contact Us",
		// 				"type": "contact",
		// 				"mailTo": "send_email_to_id",
		// 				"data": [
		// 					{
		// 						"reason": "Reason 1 specification",
		// 						"instruction": "To help you faster, please supply screenshots where possible. Thanks! 😀",
		// 						"uploadRequired": true
		// 					},
		// 					{
		// 						"reason": "Reason 2 specification",
		// 						"instruction": "",
		// 						"uploadRequired": false
		// 					}
		// 				]
		// 			}
		// 		]
		// 	},
		// 	{
		// 		"name": "Store Visitation",
		// 		"icon": "../../../../../assets/images/store.png",
		// 		"doesRequireLogin": true,
		// 	},
		// 	{
		// 		"name": "Creation Center",
		// 		"icon": "../../../../../assets/images/creation.png",
		// 		"doesRequireLogin": true,
		// 	},
		// 	{
		// 		"name": "Rewards",
		// 		"icon": "../../../../../assets/images/rewards.png",
		// 		"doesRequireLogin": true,
		// 	},
		// 	{
		// 		"name": "Analytics",
		// 		"icon": "../../../../../assets/images/analytics.png",
		// 		"doesRequireLogin": true,
		// 	},
		// 	{
		// 		"name": "Login Issues",
		// 		"icon": "../../../../../assets/images/analytics.png",
		// 		"doesRequireLogin": false,
		// 		"subCategories": {
		// 			"name": "How To Videos",
		// 			"type": "video",
		// 			"data": [
		// 				{
		// 					"name": "Contact Us",
		// 					"type": "contact",
		// 					"mailTo": ["vipulsharma9696@gmail.com"], // change this later on
		// 					"data": [
		// 						{
		// 							"reason": "Reason 1 specification",
		// 							"instruction": "To help you faster, please supply screenshots where possible. Thanks! 😀",
		// 							"uploadRequired": true
		// 						},
		// 						{
		// 							"reason": "Reason 2 specification",
		// 							"instruction": "",
		// 							"uploadRequired": false
		// 						}
		// 					]
		// 				}
		// 			]
		// 		}
		// 	},
		// ];

		// prod json
		this.supportCategoriesData = [
			{
				"name": "Help me, please!",
				"icon": "../../../../../assets/gifs/Flip_Hands_Wink_Wave_100px.gif",
				"doesRequireLogin": false,
				"subCategories": [
					{
						"name": "Contact Us",
						"type": "contact",
						"mailTo": ["terry@terryhawkins.com", "Samantha@terryhawkins.com", "draymond@mobilett.com.au"], // change this later on
						"data": [
							{
								"reason": "Please select a reason",
								"instruction": "To help us help you faster, please supply screenshots where possible. Thanks! 😀",
								"uploadRequired": false
							},
							{
								"reason": "Having Login Issue/s",
								"instruction": "To help us help you faster, please supply screenshots where possible. Thanks! 😀",
								"uploadRequired": false
							},
							{
								"reason": "Specific Issue",
								"instruction": "To help us help you faster, please supply screenshots where possible. Thanks! 😀",
								"uploadRequired": true
							},
							{
								"reason": "General Enquiry",
								"instruction": "To help us help you faster, please supply screenshots where possible. Thanks! 😀",
								"uploadRequired": false
							}
						]
					}
				]
			},
		];

		this.filterNoLoginCategories();
		const inputElement = this.el.nativeElement.querySelector('input');
		if (inputElement) {
			inputElement.addEventListener('focus', () => {
				// Blur the input to prevent zoom
				inputElement.blur();
			});
		}

		this.contactUsData = await this.helpSupportService.getContactUsEmails();
		// console.log(this.contactUsData);
	}

	ngAfterViewInit() {
		// setTimeout(() => {
		// 	this.getBoxDimensions();
		// }, 2000);
	}

	openMainHelpPage() {
		this.isCategorySelected = false;
		this.selectedCategory = "";
		this.selectedSubcat = "";
		this.showForm = true;
	}

	selectCategory(category: any) {
		this.isCategorySelected = true;
		this.selectedCategory = category;
		this.selectedSubcat = category.subCategories[0];
		this.selectedContactReason = this.selectedSubcat.data[0].reason;
	}

	selectSubcat(subcat: any) {
		this.selectedSubcat = subcat;
		this.selectedContactReason = this.selectedSubcat.data[0].reason;
	}

	closeModal() {
		this.dialogRef.close()
	}

	playVideo(videoElement: HTMLVideoElement) {
		// console.log(videoElement)
		if (videoElement.requestFullscreen) {
			videoElement.requestFullscreen();
		}

		videoElement.play();
	}

	areFieldsValid() {
		// console.log('name', this.fullName.trim().indexOf(' '))
		if (this.contactEmail && this.emailRegex.test(this.contactEmail) && this.contactMessage && this.selectedContactReason && this.selectedContactReason !== "Please select a reason") {
			if (this.selectedSubcat.data[this.selectedReasonIndex].uploadRequired && this.imageFiles.length <= 0) {
				return false;
			}
			if (!this.fullName || this.fullName.trim().length === 0) {
				return false;
			}
			return true;
		}

		return false;
	}

	changeReason(i: number, reason: string) {
		this.selectedReasonIndex = i;
		this.selectedContactReason = reason;
	}

	async createSupportRequest() {
		if (!this.areFieldsValid()) {
			this.snackbar.open("Please make sure all the fields are valid and you have attached a screenshot if required", "OK")
		} else {
			this.showForm = false;
			let emailTo: any = this.getEmails();
			let requestData: any = {
				email: this.contactEmail,
				emailTo,
				brand: this.selectedOrganizationName,
				fullName: this.fullName,
				store: this.store,
				contactReason: this.selectedContactReason,
				userName: this.userName,
				message: this.contactMessage,
				imageFiles: this.imageFiles,
			};
			// console.log('requestData', requestData)
			if (this.imageFiles.length >= 1) {
				requestData.doesContainFiles = true;
			} else {
				requestData.doesContainFiles = false;
			}
			// console.log(requestData);

			await this.spinner.show("blockLoader");
			await this.helpSupportService.createSupportRequest(requestData);
			await this.spinner.hide("blockLoader");
			this.resetForm();
		}
	}

	resetForm() {
		this.contactMessage = "";
		this.selectedContactReason = "Please select a reason";
		this.selectedReasonIndex = 0;
		this.imageFiles = [];
		this.files = [];
		this.store = '';
		this.selectedOrganizationName = '';
		this.contactEmail = "";
		// If not logged in, clear user details too
    	if (!this.isUserLoggedIn) {
	        this.fullName = "";
    	    this.userName = "";
    	}
	}

	getEmails() {
		const orgName = this.selectedOrganizationName.toLowerCase().trim();
		if (Object.keys(this.contactUsData).includes(orgName)) {
			return this.contactUsData[orgName]['emails'];
		} else {
			return this.contactUsData['unknown']['emails'];
		}
	}

	openVideoModal(videoUrl: string) {
		// console.log('videoUrl', videoUrl);
		this.selectedVideoUrl = videoUrl;
		this.showVideoModal = true;
	}

	closeVideoModal() {
		this.selectedVideoUrl = '';
		this.showVideoModal = false;
	}

	filterNoLoginCategories() {
		this.noLoginCategories = this.supportCategoriesData.filter((category: any) => !category.doesRequireLogin);
	}

	onFileSelect(event: any) {
		const selectedFiles = event.target.files;
		const validExtensions = [".jpg", ".jpeg", ".png", ".avif"];

		if (selectedFiles) {
			for (let i = 0; i < selectedFiles.length; i++) {
				const fileName = selectedFiles[i].name;
				const fileExtension = fileName.substring(fileName.lastIndexOf('.'));

				if (validExtensions.indexOf(fileExtension) < 0) {
					this.snackbar.open("Please make sure that only valid image files are selected here", "OK");
				} else {
					this.files.push(selectedFiles[i]);
					this.readFileAsBase64(selectedFiles[i]);
				}
			}
		}
	}

	removeFile(index: number) {
		this.files.splice(index, 1);
		this.imageFiles.splice(index, 1);
	}

	private readFileAsBase64(file: File) {
		const reader = new FileReader();
		reader.onload = () => {
			const base64String = reader.result as string;
			this.imageFiles.push(base64String);
		};
		reader.readAsDataURL(file);
	}

	getSafeBase64(index: number): any {
		return this.sanitizer.bypassSecurityTrustResourceUrl(this.imageFiles[index]);
	}

	filterOrganizations() {
		const selOrg = this.selectedOrganizationName.toLowerCase().trim();

		if (selOrg && selOrg.length >= 1) {
			// console.log(this.contactUsData);
			let brandNames = [...Object.keys(this.contactUsData)];
			brandNames = brandNames.filter(name => {
				return name !== "unknown";
			});
			const filteredNames = [];

			for (let name of brandNames) {
				if (name.startsWith(selOrg)) {
					filteredNames.push(this.contactUsData[name]['displayName']);
				}
			}

			// console.log(filteredNames);
			this.filteredOrganizations = filteredNames;
		} else {
			this.filteredOrganizations = [];
		}
		// console.log(this.filteredOrganizations)
	}

	// selectOrganization(org: any) {
	// 	// this.selectedOrganizationName = org.name;
	// 	this.filteredOrganizations = [];
	// }

	async getUserData() {
		let userId: any = localStorage.getItem('userId');
		this.userDetails = await this.usersService.getUserDetails(userId);
		// console.log('userDetails', this.userDetails);

		// console.log('orgData', orgData);
		if (this.userDetails) {
			this.contactEmail = this.userDetails.email;
			this.fullName = this.userDetails.name;
			if (this.userDetails.empCode) {
				this.userName = this.userDetails.empCode;
			} else {
				this.userName = this.userDetails.email;
			}

			if (this.contactEmail.endsWith(".ignite")) {
				this.contactEmail = "";
			}

			this.shouldEmailBeDisabled = this.emailDisableCheck();

			// if (orgData) {
			// 	this.selectedOrganizationName = orgData.name;
			// }
		}
	}

	onOptionSelected(event: MatAutocompleteSelectedEvent): void {
		// Do something with the selected option if needed
		// console.log('Selected Option: ', event.option.value);
		// Clear the input field after selection if needed
		// console.log(event.option.value);
		this.selectedOrganizationName = event.option.value;
		this.filteredOrganizations = [];
	}

	emailDisableCheck() {
		if (this.isUserLoggedIn && this.contactEmail.length >= 1 && !this.contactEmail.endsWith(".ignite")) {
			return true;
		} else {
			return false;
		}
	}

	// getBoxDimensions() {
		// const divHeight = this.boxElement.nativeElement.offsetHeight;
		// const divWidth = this.boxElement.nativeElement.offsetWidth;
		// if(divWidth) this.dyanamicWidth = divWidth;
		// console.log('Div Height:', divHeight);
		// console.log('Div divWidth:', divWidth);
	// }
}